import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { TextField } from 'core/components/text-field';
import { useStore } from 'core/store';

// Required for everyone who confirms a change, agents included, so it carries no Internal tag. Kept in the policy
// store, read here and by the Preview modal (which opens with it), so typing doesn't re-render the Details form.
const NoteForTheFile = observer(function NoteForTheFile({ error, onEdit }) {
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  return (
    <TextField
      id="make-a-change-note"
      label="Note for the file"
      placeholder="Why the customer asked for this change"
      fullWidth
      multiline
      minRows={3}
      maxRows={8}
      value={policyStore.makeChangeNote}
      onChange={(event) => {
        policyStore.setMakeChangeNote(event.target.value);
        onEdit();
      }}
      error={!!error}
      helperText={error}
    />
  );
});

NoteForTheFile.propTypes = {
  error: PropTypes.string,
  onEdit: PropTypes.func.isRequired
};

NoteForTheFile.defaultProps = {
  error: null
};

export default NoteForTheFile;
